<template>
  <v-dialog :value="value" persistent width="900" @click:outside="close()">
    <v-card>
      <v-card-title class="pl-6 pr-2 pt-4 pb-0">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        <div class="title h6">
          Net Unit Allowance Warning
        </div>
      </v-card-title>
      
      <v-container fluid class="pa-0">
        <div class="mx-6 my-4">
          Please review before proceeding. The following promo items have a net unit allowance amount less than $0.10.
        </div>
        <v-data-table
          :items="promoItems"
          :headers="headers"
          class="mx-4"
          no-data-text="No promo item net unit allowance violations"
          dense
          fixed-header
          disable-pagination
          hide-default-footer
          :items-per-page="-1"
          :height="tableHeight">
          <template v-slot:[`item.item.description`]="{ item }">
            <v-tooltip bottom v-if="item.item.description">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{item.item.description.substring(0, 10)}}{{item.item.description.length > 10 ? '...' : ''}}
                </span>
              </template>
              <span>{{item.item.description}}</span>
            </v-tooltip>
            <span v-else>-</span>
          </template>
          <template v-slot:[`item.net_unit_allowance`]="{ item }">
            <span v-if="item.net_unit_allowance || item.net_unit_allowance === 0">${{$config.formatCurrency(item.net_unit_allowance)}}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:[`item.sum_scan_allowances`]="{ item }">
            <span v-if="item.sum_scan_allowances || item.sum_scan_allowances === 0">${{$config.formatCurrency(item.sum_scan_allowances)}}</span>
            <span v-else>-</span>
          </template>
          <template v-slot:[`item.sum_billback_allowances`]="{ item }">
            <span v-if="item.sum_billback_allowances || item.sum_billback_allowances === 0">${{$config.formatCurrency(item.sum_billback_allowances)}}</span>
            <span v-else>-</span>
          </template>
        </v-data-table>
        <div class="mt-4 d-flex justify-center">
          <v-btn class="mb-4 mr-4" text @click="close()">
            Cancel
          </v-btn>
          <v-btn class="mb-4" color="warning" @click="confirm()">
            Confirm
          </v-btn>
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import { utils } from '@/mixins/utils'
import { promoItemsProperties } from '@/mixins/promo-items'
import { displayAlert } from '@/mixins/alert'
export default {
  name: 'NetUnitAllowanceAlertModal',
  mixins: [displayAlert, utils, promoItemsProperties],
  props: [
    'value',
    'promoItems'
  ],
  data() {
    return {
      headerProps: {
        sortable: false,
        class: 'accent white--text'
      },
      baseHeaders: [
        { text: 'Source', value: 'item.source_name' },
        { text: 'Item ID', value: 'item.item_id' },
        { text: 'Description', value: 'item.description' },
        { text: 'Net Unit Allowance', value: 'net_unit_allowance' },
        { text: 'Scan Allowances', value: 'sum_scan_allowances' },
        { text: 'Billback Allowances', value: 'sum_billback_allowances' },
        { text: 'Qty Per Case', value: 'promo_item_qty_per_case' }
      ]
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('submitWithNetUnitAllowanceAlert')
    }
  },
  computed: {
    headers () {
      return this.baseHeaders.map(header => {
        return { ...this.headerProps, ...header }
      })
    },
    tableHeight() {
      return this.promoItems.length <= 3 ? '135px' : this.promoItems.length <= 7 ? '315px' : '450px'
    }
  }
}
</script>
<style>
.title {
  width: 67%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>